import {
  type Control,
  Controller,
  type FieldValues,
  type Path,
} from 'react-hook-form'
import { Checkbox, FormControlLabel } from '@mui/material'

interface PermissionControllerCheckboxProps<TFormValues extends FieldValues> {
  onChange: () => void
  name: Path<TFormValues>
  label: string
  control: Control<TFormValues, any, any>
}

export const PermissionControllerCheckbox = <TFormValues extends FieldValues>({
  onChange,
  label,
  name,
  control,
}: PermissionControllerCheckboxProps<TFormValues>) => {
  return (
    <Controller
      render={({ field: { value } }) => {
        return (
          <FormControlLabel
            sx={{ pt: '6px' }}
            control={<Checkbox checked={value} onChange={onChange} />}
            label={label}
          />
        )
      }}
      name={name}
      control={control}
    />
  )
}
